export default {
  UNKNOWN_ERROR: { msg: `앱에서 알 수 없는 오류가<br/>발생하였습니다.<br/>문제가 지속되는 경우 <br/><span style="color: #00c3e1">고객센터로</span> 연락해 주세요.`, localeCode: 'msg001'},
  INTERNAL_SERVER_ERROR: { msg: `서버 접속에 실패하였습니다.<br/> 잠시후 다시 이용해 주세요.<br/>문제가 지속되는 경우 <span style="color: #00c3e1">고객센터로</span> 연락해 주세요.`, localeCode: 'msg002'},
  CONCURRENT: { msg: `해당 계정으로 다른 기기에서 동시접속 되었습니다.<br/>보안을 위해 자동으로 앱을 종료하였습니다.`, localeCode: 'msg003'},
  TIME_OUT: { msg: `30분 이상 사용하지 않아 앱을 종료합니다.`, localeCode: 'msg004' },
  NETWORK_ERROR: { msg: `네트워크 상태를 확인하고<br/>다시 시도해 주세요.`, localeCode: 'msg037'},
  INVALID_ACCESS: { msg: `올바르지 않는 접근 경로입니다.<br/>확인 후 이용해 주세요.`, localeCode: 'msg005'},
  APP_LONG_TIME: { msg: '장시간 앱을 이용하지 않아 앱이 종료됩니다.', localeCode: 'msg038'},
  END_OF_STUDY: `AI바로셈 학습이 종료된 회원입니다.<br/><span style="color: #00c3e1">고객센터</span>로 문의해주세요.`,
  OCR_AVERAGE_MSG: {
    '99.9': { msg: '촬영한 문제와 같은 유형의 학습을 찾았어! 공부해 볼까?', localeCode: 'LC_09_04.msg007'},
    '50': { msg: '촬영한 문제와 같은 유형의 학습을 찾았어! 공부해 볼까?', localeCode: 'LC_09_04.msg007'},
    '33.3': { msg: '촬영한 문제와 같은 유형의 학습을 찾았어! 공부해 볼까?', localeCode: 'LC_09_04.msg007'},
    '25': { msg: '촬영한 문제와 같은 유형의 학습을 찾았어! 공부해 볼까?', localeCode: 'LC_09_04.msg007'},
    '20': { msg: '촬영한 문제와 같은 유형의 학습을 찾았어! 공부해 볼까?', localeCode: 'LC_09_04.msg007'},
    '16.7': { msg: '촬영한 문제와 같은 유형의 학습을 찾았어! 공부해 볼까?', localeCode: 'LC_09_04.msg007'},
    '80': {msg: '촬영한 문제와 관련 있는 학습이야. 한번 해볼까?', localeCode: 'LC_09_04.msg008'},
    '40': {msg: '촬영한 문제와 관련 있는 학습이야. 한번 해볼까?', localeCode: 'LC_09_04.msg008'},
    '5': {msg: '촬영한 문제와 가장 비슷한 학습이야. 공부하면 도움이 될 거야.', localeCode: 'LC_09_04.msg009'},
    '2.5': {msg: '촬영한 문제와 가장 비슷한 학습이야. 공부하면 도움이 될 거야.', localeCode: 'LC_09_04.msg009'},
    'empty': { msg: '서비스 준비 중인 문제야,<br/> 다른 문제를 촬영해 줘.', localeCode: 'LC_09_04.msg012'},
    'null': {msg: '촬영한 문제와 관련있는 학습은 아니지만 공부하면 도움이 될 꺼야.', localeCode: 'LC_09_04.msg011'},
  }
}